import { render, staticRenderFns } from "./VueComponentsTablePage.vue?vue&type=template&id=7b712ce4&scoped=true"
import script from "./VueComponentsTablePage.vue?vue&type=script&lang=js"
export * from "./VueComponentsTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b712ce4",
  null
  
)

export default component.exports